/**
 * 选择单个元素
 * @param {String} selector css 选择器
 * @param {Object} context 上下文，默认是 document
 */
export function $(selector, context) {
  context = context || document
  return context.querySelector(selector)
}

/**
 * 选择全部满足选择器件的元素
 * @param {String}} selector css 选择器
 * @param {Object} 上下文，默认是 document
 */
export function $$(selector, context) {
  context = context || document
  return Array.prototype.slice.apply(context.querySelectorAll(selector))
}
